const allroles = { data: [], loading: true };
const allrolescrm = { data: [], loading: true };

export const GetAllRoles = (state = allroles, action) => {
  switch (action.type) {
    case "get_allroles":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllRolesCRM = (state = allrolescrm, action) => {
  switch (action.type) {
    case "get_allrolescrm":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

// const allroles = { data: [], loading: true };
// export const GetAllRoles = (state = allroles, action) => {
//   switch (action.type) {
//     case "get_allroles":
//       return {
//         data: action.payload,
//         loading: action.loading,
//       };
//     default:
//       return state;
//   }
// };
